import { LoginData } from '../../../../../../core/models/login-data';
import { MatDialog } from '@angular/material/dialog';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { ChangeStatusComponent } from '../../components/change-status/change-status.component';
import { AbstractControl, FormArray, FormBuilder, Validators } from '@angular/forms';
import { GetSecondHandOrdersService } from '../../services/get-second-hand-orders.service';
import { ToastService } from 'src/app/core/toast.service';
import { LoginService } from 'src/app/core/services/login.service';
import { SecondHandSuppliesOrders } from '../../models/second-hand-supplies-orders';
import { BehaviorSubject } from 'rxjs';
import { Filter } from 'src/app/core/models/filter';
import { switchMap } from 'rxjs/operators';
import { PageEvent } from '@angular/material/paginator';
import { RefundOrderComponent } from '../../components/refund-order/refund-order.component';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-listing',
  templateUrl: './listing.component.html',
  styleUrls: ['./listing.component.scss'],
  animations: [
    trigger("openCloseFilter", [
      state('true', style({ height: '*', opacity: '1' })),
      state('false', style({ height: '0px', opacity: '0' })),
      transition("false <=> true", [animate(500)])
    ])
  ]
})
export class ListingComponent implements OnInit {
  columnList = [
    {
      column: "customer_name",
      title: "Customer name",
      operators: [
        {title: "Contains", operator: "_ilike"},
       ],
      type: "text",
     },
     {
      column: "customer_email",
      title: "Customer email",
      operators: [
        {title: "Contains", operator: "_ilike"},
       ],
      type: "text",
     },
     {
      column: "customer_phone",
      title: "Customer phone",
      operators: [
        {title: "Contains", operator: "_ilike"},
       ],
      type: "text",
     },
     {
      column: "supplier.name",
      title: "Supplier name",
      operators: [
        {title: "Contains", operator: "_ilike"},
       ],
      type: "text",
     }
   ];
   operatorList = [];
   filterForm = this.fb.group({
     status: ['PENDING', [Validators.required]],
     sort: [{'order_number': 'desc'}],
     search: ['', [Validators.required]],
     limit: [50, [Validators.required]],
     filters:this.fb.array([]),
     offset: [0,[Validators.required]]
   });
   totalElements = 0;
   filterSubject: BehaviorSubject<Filter> = new BehaviorSubject<Filter>(this.filterForm.value);
   /* --------------------------------- FIELDS -------------------------------- */
   // FILTER-FUNCTIONALITIES
   openFilter = false;
   displayedColumns: string[] = [
     'order_number',
     'customerName',
     'contactEmail',
     'contactNumber',
     'total_amount',
     'payment_status',
     'payment_mode',
     'action'
    ];

   dataSource: MatTableDataSource<SecondHandSuppliesOrders>;

   statusWiseCount: any;
   selection = new SelectionModel<SecondHandSuppliesOrders>(true, []);

   loginData: LoginData;

/* ------------------------------- Constructor ------------------------------ */

   constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    private getSecondHandOrdersService: GetSecondHandOrdersService,
    private toast: ToastService,
    private loginService: LoginService,
    private route: ActivatedRoute
  ) {
    if(this.route.snapshot.paramMap.get('status')){
      this.status.setValue(this.route.snapshot.paramMap.get("status"));
    }
    this.loginData = this.loginService.getLoginData();
   }
  /* ----------------------------- NG-LIFE-CYCLES ----------------------------- */
  ngOnInit(): void {
    if(this.loginData.type === 'ADMIN'){
      this.displayedColumns = [
        'order_number',
        'customerName',
        'contactEmail',
        'contactNumber',
        'supplierName',
        'total_amount',
        'payment_status',
        'payment_mode',
        'action'
       ];
    } else {
      this.displayedColumns = [
        'order_number',
        'customerName',
        'contactEmail',
        'contactNumber',
        'total_amount',
        'payment_status',
        'payment_mode',
        'action'
       ];
    }
    this.filterSubject.pipe(switchMap(filter=>{
      this.dataSource = null;
      return this.getSecondHandOrdersService.getSecondHandSuppliesOrders(filter);
    })).subscribe(([second_hand_supplies_orders, count, statusWiseCount]:[SecondHandSuppliesOrders[], number, any])=> {
      console.log(second_hand_supplies_orders, count, statusWiseCount);
      this.dataSource = new MatTableDataSource<SecondHandSuppliesOrders>(second_hand_supplies_orders);
      this.totalElements = count;
      this.statusWiseCount = statusWiseCount;
    });
  }

  /* ------------------------------ CUSTOM-METHODS ----------------------------- */
  filterToggle(): void {
    this.openFilter = !this.openFilter;
    if (this.openFilter && this.filters.length === 0) {
      this.plusField();
    }
  }
  plusField() {
    console.log("hello");
    this.filters.push(this.getField());
  }
  minusField(i: number) {
    this.filters.removeAt(i);
  }
  getField() {
    return this.fb.group({
      column : [null, [Validators.required]],
      operator: [null, [Validators.required]],
      value: [null, [Validators.required]]
    })
  }
  filterChange(){
    this.filterSubject.next(this.filterForm.value);
  }
    /** Whether the number of selected elements matches the total number of rows. */
    isAllSelected() {
      if(this.dataSource){
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
      } else {
        return false;
      }
    }
      /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if(this.dataSource){
      this.isAllSelected() ? this.selection.clear() :  this.dataSource.data.forEach(row => this.selection.select(row));
    }
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: SecondHandSuppliesOrders): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row`;
  }

  searchOrdersByOrderNumber(){
    this.filterSubject.next(this.filterForm.value);
  }
  setStatus(){
    this.filterSubject.next(this.filterForm.value);
  }

/* --------------------------------- Getters -------------------------------- */

  changeStatusDialog(supplies_orders: SecondHandSuppliesOrders) {
    const dialogRef = this.dialog.open(ChangeStatusComponent,
    {
      width: '40%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      data: supplies_orders
    });
    dialogRef.afterClosed().subscribe(status=>{
      console.log(status);
      if(status === 'yes'){
        this.filterSubject.next(this.filterForm.value);
      }
      if(status === 'no'){

      }
    })
  }

  refundOrderDialog(supplies_orders: SecondHandSuppliesOrders) {
    const dialogRef = this.dialog.open(RefundOrderComponent,
    {
      width: '30%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      data: supplies_orders
    });
    dialogRef.afterClosed().subscribe(status=>{
      console.log(status);
      if(status === 'yes'){
        this.filterSubject.next(this.filterForm.value);
      }
      if(status === 'no'){

      }
    })
  }

  /* ------------------------------- FilterForm ------------------------------- */
  get sort(){
    return this.filterForm.get('sort');
  }
  get search(){
    return this.filterForm.get('search');
  }
  get status(): AbstractControl {
    return this.filterForm.get("status");
  }
  get limit(): AbstractControl {
    return this.filterForm.get('limit');
  }
  get offset(): AbstractControl {
    return this.filterForm.get('offset');
  }
  get filters(): FormArray {
    return this.filterForm.get('filters') as FormArray;
  }

  changePage(e: PageEvent){
    this.offset.setValue(e.pageSize * e.pageIndex);
    this.filterSubject.next(this.filterForm.value);
  }

  clearFilters() {
    this.openFilter = false;
    this.filters.clear();
    this.filterSubject.next(this.filterForm.value);
  }

  viewInvoice(order: SecondHandSuppliesOrders){
    window.open(`https://dental-360.herokuapp.com/api/v1/event/get-secondhand-invoice/${order.id}`);
  }

  changeSort(ev:any){
    if(!ev.direction){
      this.sort.setValue({created_at: "desc"});
    } else {
      this.sort.setValue({[ev.active]: ev.direction});
    }
    this.filterSubject.next(this.filterForm.value);
  }

}
